import React from 'react';
import { Box, Typography, Button } from '@mui/material';
import { useStyles } from './styles';

import spotlight from '../../../../Assets/images/blueHue.png';
import zeeLogo from '../../../../Assets/images/zeeLogo.svg';
import icon1 from '../../../../Assets/images/spotIcon1.svg';
import icon2 from '../../../../Assets/images/spotIcon2.svg';
import icon3 from '../../../../Assets/images/spotIcon3.svg';
import routes from '../../../../Utils/routes';
import { useNavigate } from 'react-router-dom';

const spotlightCards = [
  {
    icon: icon1,
    text: 'It’s a platform built to spotlight ambition in all its forms: early ideas, growing ventures, and deep technologies that define our future.',
  },
  {
    icon: icon2,
    text: 'Whether you’re solving a small-town problem or building IP for the global stage, Ideabaaz is where your story begins.',
  },
  {
    icon: icon3,
    text: 'Ideabaaz is for Founders who never had a network. For regions that never had a voice. For dreamers building in silence.',
  },
];

const SpotlightSection = () => {
  const classes = useStyles();
  const navigate = useNavigate();

  return (
    <Box className={classes.section}>
      <Box className={classes.contentWrapper}>
        <img src={spotlight} alt="Spotlight" className={classes.spotlightImg} />
        <Typography variant="h2" className={classes.heading}>
          A national spotlight
          <br />
          for your ideas
        </Typography>
        <Typography className={classes.subtext}>
          Ideabaaz is more than a televised pitch - it’s built for India. <br />
          It signals that India is ready to build everywhere, in every way.
        </Typography>

        <Box className={classes.cardsWrapper}>
          {spotlightCards.map((card, index) => (
            <Box key={index} className={`${classes.card} ${index === 1 ? classes.cardRight : classes.cardLeft}`}>
              <img src={card.icon} alt={`icon-${index}`} className={classes.cardIcon} />
              <Typography className={classes.cardText}>{card.text}</Typography>
            </Box>
          ))}
        </Box>
        {/* 
        <Button className={classes.ctaBtn} onClick={() => navigate(routes.login)}>
          Ideabaaz is for India.
        </Button> */}

        <img src={zeeLogo} alt="ZeeTV" className={classes.zeeLogo} />
      </Box>
    </Box>
  );
};

export default SpotlightSection;
